import React, { useEffect, useState } from "react";
import closeIcon from "../../../../../public/images/close_grey.svg";
import styles from "../../../css/community-popup.module.css";
import MaterialTextFieldOutlinedContainer from "../../../../admin/containers/MaterialTextFieldOutlinedContainer";
import ActionButtonContainer from "../../../../shared/containers/ActionButtonContainer";
import { useDispatch, useSelector } from "react-redux";
import { addAnswer, editAnswer } from "../../../../shared/utils/sash-v2-api";
import { COMMUNITY_ACTION_TYPES } from "../communityReducer";

const AddEditAnswerPopUp = (props) => {
  const [answer, setAnswer] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const userAnswers = useSelector((state) => state.communityReducer.userAnswers);
  const userId = useSelector((state) => state.userReducer.userId);
  const [enabled, setEnabled] = useState(false);

  const isEditMode = props.selectedAnswerId !== null;
  const dispatch = useDispatch();

  useEffect(() => {
    setEnabled(!answer?.trim());
  }, [answer]);

  useEffect(() => {
    if (props.selectedAnswer) {
      setAnswer(props.selectedAnswer);
    }
  }, [props.selectedAnswer]);

  const handleAnswerChange = (value) => setAnswer(value);

  const handleSave = () => {
    if (!answer.trim()) {
      setErrorMessage("All Fields are mandatory*");
      return;
    }
    setErrorMessage("");

    if (isEditMode) {
      const updatedAnswer = {
        community_answer: answer.trim(),
        isVerified:false
      };

      const editAnswerSuccess = (res) => {
        const { result } = res;
        if (result === "SUCCESS") {
          const updatedUserAnswers = userAnswers.map(item => {
            if (item.question?._id === props.threadId || item._id === props.threadId ) {
              const updatedItem = {
                ...item,
                answers: item.answers.map((answer) => {
                  if (answer._id === props.selectedAnswerId) {
                    const updatedAnswerObj = { ...answer, ...updatedAnswer };
                    return updatedAnswerObj;
                  }
                  return answer;
                }),
              };
              return updatedItem
            }
            return item;
          });
          dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
            payload: updatedUserAnswers,
          });
          props.onClose();
          const updatedAnswers = props.answers.answers.map((answer) => {
            if (answer._id === props.selectedAnswerId) {
              return { ...answer, ...updatedAnswer };
            }
            return answer;
          });

          const updatedPropsAnswers = {...props.answers, answers: updatedAnswers};
          props.setSelectedThread(updatedPropsAnswers)

        }
        props.onClose();
      };

      const editAnswerFailure = (error) => {
        console.error("Error editing answer:", error);
      };
      editAnswer(
          props?.selectedAnswerId,
          updatedAnswer,
          editAnswerSuccess,
          editAnswerFailure
      );
    }
    else {
      const newAnswer = {
        community_answer: answer.trim(),
        answerd_at: Date.now().toString(),
        isVerified: false,
        user_id: userId,
        question_id: props.threadId,
        // _id : mongoObjectID().toString(),
      };

      const addAnswerSuccess = (res) => {
        const { result } = res;
        if (result === "SUCCESS") {
          const updatedUserAnswers = userAnswers.map((item) => {
            if (item.question?._id === props.threadId) {
              const updatedAnswers = [...item.answers, newAnswer];
              return {
                ...item,
                answers: updatedAnswers,
                answer_count: updatedAnswers.length,
              };
            }
            return item;
          });
          dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
            payload: updatedUserAnswers,
          });
          const updatedAnswer = {
            ...props.answers,
            answers:[...props.answers.answers, newAnswer],
            answers_count: props.answers.answers.length + 1,
          }
          props.setSelectedThread(updatedAnswer);
        }
        window.location.reload()
      };
      props.onClose();

      const addAnswerFailure = (error) => {
        console.error("Error adding answer:", error);
        setErrorMessage("An error occurred while adding the answer. Please try again.");
      };

      addAnswer(props.threadId, newAnswer, addAnswerSuccess, addAnswerFailure, userId);
    }
  };

  return (
      <div style={{ height: "260px" }} className={styles.popupContainer}>
        <div className={styles.type}>
          <h4>{isEditMode ? "Edit Answer" : "Add Answer"}</h4>
          <img
              onClick={props.onClose}
              className={styles.communityPopUpClose}
              height={12}
              src={closeIcon}
              alt="close icon"
          />
        </div>
        <div className={styles.communityErrorMessage}>
          <MaterialTextFieldOutlinedContainer
              autoFocus={true}
              placeHolder={"Answer"}
              textArea={true}
              customStyleObject={{ height: "150px" }}
              onChange={handleAnswerChange}
              defaultValue={answer}
              value={answer}
          />
          {errorMessage && (<p style={{color: "red", textAlign: "center", fontSize: "14px", margin: "0",}}>{errorMessage}</p>)}
          <div className={styles.buttonType}>
            <ActionButtonContainer
                buttonText={isEditMode ? "EDIT" : "SAVE"}
                handleClick={handleSave}
                height="40px"
                bgColor={enabled ? "#E0E0E0" : ""}
                buttonWidth="100px"
                fontWeight="bold"
            />
          </div>
        </div>
      </div>
  );
};

export default AddEditAnswerPopUp;